import { EntityCollectionServiceBase, QueryParams } from '@ngrx/data';
import { Observable } from 'rxjs/index';

export abstract class WebSocketEntityCollectionServiceBase<T> extends EntityCollectionServiceBase<T> {
    subscribeWebSocketJob(parameters: QueryParams): Observable<Array<T>> {
        const webSocketActionParameters = {...parameters, wsAction: 'subscribe'};

        return super.getWithQuery(webSocketActionParameters);
    }

    unsubscribeWebSocketJob(): Observable<Array<T>> {
        const webSocketActionParameters = {wsAction: 'unsubscribe'};

        return super.getWithQuery(webSocketActionParameters);
    }

    refreshWebSocketJob(parameters: QueryParams): Observable<Array<T>> {
        const webSocketActionParameters = {...parameters, wsAction: 'refresh'};

        return super.getWithQuery(webSocketActionParameters);
    }

    resetWebSocketJob(parameters: QueryParams): void {
        this.clearCache();
        this.refreshWebSocketJob(parameters); // backend will reset offset when personId is different
    }
}
